import { useState, useEffect } from 'react';

import Typography from '../Typography';
import AmPmToggle from '../AmPmToggle';
import TimeNumberInput from '../TimeNumberInput';

import { TimeParts, pad } from './helpers';

export function TimeEditor({
  initialValue,
  onChange,
  error,
  setError,
}: {
  initialValue: TimeParts;
  onChange: (value?: TimeParts) => void;
  error?: string;
  setError: (err: string) => void;
}) {
  const [timeParts, setTimeParts] = useState<TimeParts>({
    hours: pad(initialValue.hours),
    minutes: pad(initialValue.minutes),
    isPm: initialValue.isPm,
  });

  useEffect(() => {
    const h = parseInt(timeParts.hours);
    const m = parseInt(timeParts.minutes);
    let localError = '';
    if (isNaN(h) || h < 1 || h > 12) {
      localError = 'Hours must be between 1 and 12';
    }
    if (isNaN(m) || m < 0 || m > 59) {
      localError = localError
        ? `${localError}; Minutes must be between 0 and 59`
        : 'Minutes must be between 0 and 59';
    }
    setError(localError);

    onChange(error ? undefined : timeParts);
  }, [onChange, timeParts]);

  // const err = error || externalError;

  return (
    <div className="flex flex-col gap-[13px]">
      <Typography variant="p3" fontWeight={400}>
        Time
      </Typography>
      <div className="flex gap-2">
        <div className="flex gap-1 h-fit">
          <TimeNumberInput
            min={1}
            max={12}
            placeholder="HH"
            value={timeParts.hours}
            onChange={(hours) => setTimeParts((p) => ({ ...p, hours }))}
          />
          <span className="mt-1">:</span>
          <TimeNumberInput
            min={0}
            max={59}
            placeholder="mm"
            value={timeParts.minutes}
            onChange={(minutes) => setTimeParts((p) => ({ ...p, minutes }))}
          />
        </div>
        <AmPmToggle
          value={timeParts.isPm}
          onChange={(isPm) => setTimeParts((p) => ({ ...p, isPm }))}
        />
      </div>
      {error && (
        <Typography variant="p3" fontWeight={400} color="text-red">
          {error}
        </Typography>
      )}
    </div>
  );
}
